import { Dashboard } from "./Dashboard";
import { useParams } from "react-router-dom";
import { useProject } from "../hooks";

export function ProjectDashboard() {
  const { id } = useParams();
  const project = useProject(id);

  if (project.isLoading) {
    return <p>Loading...</p>;
  } else if (project.isError) {
    return <p>An unknown error occurred.</p>;
  } else if (project.isSuccess) {
    return <Dashboard project={project.data} />;
  } else {
    return <p>Project not found.</p>;
  }
}
